import React, {useState, useEffect} from "react";
import Alert from "@mui/material/Alert";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import {currencyFormat} from "../../../utils/helpsers";

/**
 *
 * @param salaryData {object} Salaries from all years.
 * @constructor
 */
function SalaryTable({salaryData, staticData}) {
    const[tableData, setTableData] = useState({});
    const[noData, setNoData] = useState(false);

    function compareNumbers(a, b) {
        return b - a;
    }

    useEffect(() => {
        // If year is null the last year with data is served.

        const salaryYear = salaryData?.file_year || salaryData?.salary_data?.data?.map(el => el.year).sort(compareNumbers)[0];
        const reducedData = [];

        const yearIndex = (salaryData?.salary_data.data)?.findIndex( item => {
            return item.year === salaryYear;
        });
        // If the year is not in the array of data.
        setNoData(yearIndex === -1);

        if (yearIndex >= 0 && salaryData?.salary_data.data.length) {
            let startIndex = yearIndex === 0 ? 0 : (yearIndex - 1),
                endIndex = yearIndex === 0 ? (yearIndex + 2) : (yearIndex + 1);

            if((yearIndex + 1) === (salaryData?.salary_data.data).length) {
                startIndex = (yearIndex - 2);
                endIndex = yearIndex;
            }

            reducedData.push(...salaryData?.salary_data.data.slice(startIndex, endIndex + 1));
        }

        if(reducedData.length) {
            let level = salaryData?.salary_data.level,
                tableColumns= reducedData.map( item => item?.year),
                rowBaseSalary = reducedData.map( item => item[`base_salary_${level}`] ?  currencyFormat(item[`base_salary_${level}`]) : "Not in SERB"),
                rowAnnualRaise = reducedData.map( item => item.negotiated_annual_raise ? `${item.negotiated_annual_raise}%` : "Not in SERB");

            // Build static data rows to math with the column year.
            const staticDataRows = staticData?.map( el => {
                const staticDataVar = el[1]
                const dataByYear = [];
                // If file_years is null is MCD
                const fileYear = salaryData.file_year;
                const baseSalaryVars = ['base_salary_ba', 'base_salary_ma']

                // Formatting value for money values when year is not MCD.
                if (baseSalaryVars.includes(el[0]) && !staticDataVar?.value.includes('$')) {
                    staticDataVar.value = `$${staticDataVar?.value}`
                }

                // Created rows using year to match column.
                tableColumns.forEach( year => {
                    return dataByYear.push( (fileYear === year || staticDataVar.label.includes(`${year}`)) ? staticDataVar.value : '')
                })

                return [staticDataVar.label, ...dataByYear]
            })

            setTableData({
                columns: tableColumns,
                rows: [
                    [salaryData?.column_data[`${level}_base_salary`].label, ...rowBaseSalary],
                    [salaryData?.column_data.negotiated_annual_raise.label, ...rowAnnualRaise],
                  // Adding static data rows
                  ...staticDataRows
                ]
            })
        }



    }, [salaryData, staticData]);

    if (noData) return <Alert severity="warning">No data for selected year</Alert>

    return (
        Object.keys(tableData).length &&
            <TableContainer className="TableContent DistrictCard__data">
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell align="left"><span></span></TableCell>
                            { (tableData.columns).map( item =>
                                <TableCell align="left" key={item}><span>{item}</span></TableCell>
                            )}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {(tableData.rows).map( (row, i) => (
                            <TableRow className={`${ i === 2 ? "row-divider" : ""} ${i >= 2 ? "extra-data" : ""}`} key={i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                {
                                    row.map( (val, i) => <TableCell component={ i ? 'td' : 'th'} key={i} align="left">{ val }</TableCell>)
                                }
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
    )
}

export default SalaryTable;